import React, { ReactElement } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from './data/queryClient'

export const TEST_ID_REACT_QUERY_DEV_TOOLS = 'reactQueryDevTools'

type PropsType = {
	readonly children: ReactElement,
}

export const QueryClientWrapper: React.FC<PropsType> = ( { children } ) => {
	return <QueryClientProvider client={queryClient}>
		{children}
	</QueryClientProvider>
}
